import {
  TickerPayload,
  UpdateHandler,
} from '@terminal/services/price-ws/types';

export const getTickerKey = (t: TickerPayload) =>
  `${t.ticker}|${t.trading_country}`;

export const isTickerInList = (ticker: TickerPayload, list: TickerPayload[]) =>
  list.some(
    t =>
      t.ticker === ticker.ticker && t.trading_country === ticker.trading_country
  );

export type WsInitConfig = {
  updateHandler: UpdateHandler;
  delayedPrices: boolean;
};

export interface SubscribeData {
  tickers: TickerPayload[];
  updateHandler: UpdateHandler;
  delayedPrices: boolean;
}
